import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';

import { FETCH_CANDIDATE_PUBLIC_PROFILE } from 'api/public_profile_api';
import PublicProfile from 'components/CandidateComponents/CandidateExperienceV1/MySearchlightV2/components/PublicProfile';
import SplashScreen from 'components/SplashScreen';
import EmptyPage from 'components/EmptyPage';

export default function CandidatePublicProfileWrapper() {
  const { code } = useParams<{ code: string }>();
  const { data, loading, error } = useQuery(FETCH_CANDIDATE_PUBLIC_PROFILE, {
    variables: {
      input: {
        code,
      },
    },
    skip: !code,
  });

  if (loading) {
    return <SplashScreen />;
  }

  const publicProfile = data.fetchCandidatePublicProfile;
  if (error || !publicProfile || !code) {
    const description =
      error?.message == 'Unable to retrieve candidate profile.'
        ? 'This profile is not active!'
        : 'There is nothing here! Double-check your URL.';
    return <EmptyPage title="404" description={description} />;
  }

  return (
    <div className="tw-bg-gray-100 tw-py-9">
      <div className="tw-max-w-4xl tw-m-auto">
        <PublicProfile
          candidatePublicProfile={publicProfile}
          isPublicView={true}
          vanityLinkText={code}
        />
      </div>
    </div>
  );
}
